import { render } from "./TvmFlowEndLink.vue?vue&type=template&id=433b0480&scoped=true"
import script from "./TvmFlowEndLink.vue?vue&type=script&lang=js"
export * from "./TvmFlowEndLink.vue?vue&type=script&lang=js"

import "./TvmFlowEndLink.vue?vue&type=style&index=0&id=433b0480&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433b0480"],['__file',"src/Components/ChatWidget/TvmFlowEndItems/TvmFlowEndLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "433b0480"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('433b0480', __exports__)) {
    api.reload('433b0480', __exports__)
  }
  
  module.hot.accept("./TvmFlowEndLink.vue?vue&type=template&id=433b0480&scoped=true", () => {
    api.rerender('433b0480', render)
  })

}


export default __exports__